
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Investments', function (Parse, InvestmentSchema, User, $log) {

		// ==================================================
		// Load object schema
		// ==================================================
		let Investment = InvestmentSchema;

		// ==================================================
		// Methods
		// ==================================================


		/**
		 * Retrieve the list of Investments
		 */
		this.list = () => {
			let query = new Parse.Query(Investment);
			query.include('Project');
			query.select('amount', 'Project.title', 'status', 'receipt_url');
			query.equalTo('User', User.getCurrent())
			return query.find();
		};


		/**
		 * Return the number of investments
		 */
		this.count = () => {
			let query = new Parse.Query(Investment);
			query.equalTo('User', User.getCurrent())
			return query.count();
		}

		/**
		 * Retrieve an Investment by ID
		 */
		this.get = id => {
			let query = new Parse.Query(Investment);
			return query.get(id);
		}


		/**
		 * Fetch investments and compute stats
		 */
		this.getStats = () => {
			let stats = [];
			let query = new Parse.Query(Investment);
			query.select('amount', 'status', 'Project');
			query.equalTo('User', User.getCurrent())
			return query.find()
				.then(donations => {
					stats.count = donations.length;
					stats.dollar_amount = donations.reduce((total, o) => total + Number(o.amount), 0);
					// stats.donations = donations;
					stats.projects = donations.reduce((list, o) => {
						if (!list.find(p => p.id === o.Project.id)) {
							list.push(o.Project)
						}
						return list;
					}, []);
					return stats;
				})
		}

	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/investments.service.js